export default "__VITE_ASSET__D3uie1og__"